/**
 *      ▄ █
 *    █ █ █▄▄  LOADBALANCER CLIENT
 *    █ █ ▄ █
 *    ▀     ▀  @copyright Copyright (c) 2024
 */
export const BillingApiEnum = {
    GET_STRIPE_KEY: '/billing/public-key',
    GET_CLIENT_SECRET_KEY: '/billing/payment-methods',
    GET_ALL_PRODUCTS: '/billing/products',
    POST_SUBSCRIPTION: '/billing/subscriptions',
    GET_SUBSCRIPTION: '/billing/subscriptions',
    DELETE_SUBSCRIPTION: (id: string): string => `/billing/subscriptions/${id}`,
    GET_INVOICES: '/billing/invoices',
    GET_BILLING_ACCOUNT: '/billing/accounts',
    POST_BILLING_ACCOUNT: '/billing/accounts',
    GET_PAYMENT_METHODS: '/billing/payment-methods',
    POST_PAYMENT_METHODS: '/billing/payment-methods',
    DELETE_PAYMENT_METHOD: (paymentId: string): string => `/billing/payment-methods/${paymentId}`,
};

